import { PdfSummaryCard, RegistryPdfDocument } from '../types/registryPdf';

export type MaterialType = 'pe' | 'ppr' | 'pvh';

const MATERIAL_TITLES: { [type in MaterialType]: string } = {
    pe: 'полиэтилен',
    ppr: 'полипропилен',
    pvh: 'поливинилхлорид',
};

// Блоки страницы цен сами загружают данные и передают для PDF то, что показывают
export interface MaterialActualPdfData {
    materialType: string;
    date: string;
    columns: string[];
    rows: string[][];
}

export interface MaterialMaxPdfData {
    materialType: string;
    tiles: { label: string; value: string }[];
}

export interface MaterialHistoryPdfData {
    materialType: string;
    period: string;
    columns: string[];
    rows: string[][];
}

export interface MaterialChartImage {
    src: string;
    width: number;
    height: number;
}


// canvas у Chart.js прозрачный, без белой подложки в JPEG будет чёрный фон
export const captureChartCanvas = (canvas: HTMLCanvasElement): MaterialChartImage => {
    const imageCanvas = document.createElement('canvas');
    imageCanvas.width = canvas.width;
    imageCanvas.height = canvas.height;
    const context = imageCanvas.getContext('2d');
    if (context) {
        context.fillStyle = '#ffffff';
        context.fillRect(0, 0, imageCanvas.width, imageCanvas.height);
        context.drawImage(canvas, 0, 0);
    }
    return { src: imageCanvas.toDataURL('image/jpeg', 0.92), width: canvas.width, height: canvas.height };
};


export const buildMaterialsDocument = (
    materialType: MaterialType,
    actual: MaterialActualPdfData | null,
    max: MaterialMaxPdfData | null,
    history: MaterialHistoryPdfData | null,
    charts: { title: string; image: MaterialChartImage }[],
): RegistryPdfDocument => {
    // Блок мог ещё не перезагрузиться после переключения вкладки, тогда его данные не берём
    const actualData = actual && actual.materialType === materialType ? actual : null;
    const maxData = max && max.materialType === materialType ? max : null;
    const historyData = history && history.materialType === materialType ? history : null;
    const materialTitle = MATERIAL_TITLES[materialType];

    const actualColumns = actualData ? actualData.columns : ['Марка', 'Стоимость', 'Производитель'];
    const cards: PdfSummaryCard[] = [
        {
            kind: 'table',
            title: 'Актуальная цена',
            subtitle: actualData ? `Дата: ${actualData.date}` : undefined,
            columns: actualColumns.map((title, index) => ({ title, weight: index === 0 ? 1.2 : 1 })),
            rows: actualData ? actualData.rows : [],
        },
        { kind: 'tiles', title: 'Максимальная цена', tiles: maxData ? maxData.tiles : [] },
    ];
    charts.forEach(chart => {
        cards.push({ kind: 'image', title: chart.title, src: chart.image.src, width: chart.image.width, height: chart.image.height });
    });

    const historyColumns = historyData ? historyData.columns : ['Дата записи'];
    let historyTitle = `История цен: ${materialTitle}`;
    if (historyData && historyData.period) historyTitle += ` (${historyData.period})`;

    return {
        fileName: `materials_${materialType}_report.pdf`,
        summary: {
            title: `Цены на полимерное сырье: ${materialTitle}`,
            subtitle: actualData ? `Актуальная цена на ${actualData.date}` : 'Актуальная цена: нет данных',
            counters: [],
            cards,
        },
        sections: [{
            kind: 'table',
            title: historyTitle,
            columns: historyColumns.map((title, index) => ({ title, weight: index === 0 ? 1.3 : 1 })),
            rows: historyData ? historyData.rows : [],
        }],
    };
};
